<template>
	<section id="categories" class="sg-section">
		<v-container>
			<h2 class="sg-section-title">دسته‌بندی زیورآلات</h2>
			<div class="sg-gold-line"></div>
			<p class="sg-section-subtitle">دسته مورد نظر خود را انتخاب کنید و محصولات را مشاهده کنید</p>

			<v-row justify="center" class="mb-8">
				<v-col v-for="cat in categories" :key="cat.id" cols="6" sm="4" md="2">
					<div class="sg-category-chip" :class="{ active: selectedCategory === cat.id }" @click="selectCategory(cat.id)">
						<div class="sg-cat-icon">
							<v-icon color="#C9A227" size="32">{{ cat.icon }}</v-icon>
						</div>
						<div class="font-weight-bold">{{ cat.name }}</div>
					</div>
				</v-col>
			</v-row>

			<transition-group name="sg-list" tag="div">
				<v-row :key="selectedCategory">
					<v-col v-for="product in filteredProducts" :key="product.id" cols="12" sm="6" md="4" lg="3">
						<v-card class="sg-product-card" elevation="0">
							<div class="sg-product-img">
								<v-icon>{{ product.icon }}</v-icon>
							</div>
							<v-card-text class="pa-4">
								<h3 class="font-weight-bold mb-2" style="font-size: 1rem;">{{ product.name }}</h3>
								<div class="d-flex flex-wrap mb-3" style="gap: 8px;">
									<span class="sg-price-tag">
										<v-icon x-small color="#C9A227">mdi-scale-balance</v-icon>
										{{ product.weight }} گرم
									</span>
									<span class="sg-price-tag">
										<v-icon x-small color="#C9A227">mdi-hammer-wrench</v-icon>
										اجرت {{ product.wage }}٪
									</span>
								</div>
								<div class="d-flex align-center justify-space-between">
									<div>
										<div class="grey--text text--darken-1" style="font-size: 0.75rem;">قیمت</div>
										<div class="font-weight-bold" style="color: #C9A227; font-size: 1.1rem;">
											{{ formatPrice(product.price) }}
											<small class="grey--text">تومان</small>
										</div>
									</div>
									<v-btn class="sg-btn-gold" small @click="$emit('order', product)">
										<v-icon left small>mdi-cart-plus</v-icon>
										ثبت سفارش
									</v-btn>
								</div>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</transition-group>

			<div v-if="!filteredProducts.length" class="text-center py-8 grey--text">
				<v-icon size="48" color="grey lighten-1">mdi-package-variant</v-icon>
				<p class="mt-3">محصولی در این دسته یافت نشد</p>
			</div>
		</v-container>
	</section>
</template>

<script>
	export default {
		name: 'CategoriesSection',
		props: {
			goldPrice: { type: Number },
		},
		data() {
			return {
				selectedCategory: 'necklace',
				categories: [
					{ id: 'necklace', name: 'گردنبند', icon: 'mdi-necklace' },
					{ id: 'ring', name: 'انگشتر', icon: 'mdi-ring' },
					{ id: 'set', name: 'ست طلا', icon: 'mdi-diamond-stone' },
					{ id: 'bracelet', name: 'دستبند', icon: 'mdi-watch-variant' },
					{ id: 'earring', name: 'گوشواره', icon: 'mdi-ear-hearing' },
					{ id: 'anklet', name: 'پابند', icon: 'mdi-foot-print' },
				],
				products: [
					{ id: 1, category: 'necklace', name: 'گردنبند طلا طرح گل', weight: 4.2, wage: 18, price: 38500000, icon: 'mdi-necklace' },
					{ id: 2, category: 'necklace', name: 'گردنبند طلا زنجیر ظریف', weight: 3.8, wage: 15, price: 34200000, icon: 'mdi-necklace' },
					{ id: 3, category: 'ring', name: 'انگشتر طلا نگین دار', weight: 2.1, wage: 20, price: 19800000, icon: 'mdi-ring' },
					{ id: 4, category: 'ring', name: 'انگشتر طلا ساده', weight: 1.8, wage: 14, price: 16500000, icon: 'mdi-ring' },
					{ id: 5, category: 'set', name: 'ست طلا گردنبند و گوشواره', weight: 8.5, wage: 17, price: 78200000, icon: 'mdi-diamond-stone' },
					{ id: 6, category: 'set', name: 'ست طلا مجلسی', weight: 12.3, wage: 22, price: 115000000, icon: 'mdi-diamond-stone' },
					{ id: 7, category: 'bracelet', name: 'دستبند طلا بافت', weight: 5.6, wage: 16, price: 51200000, icon: 'mdi-watch-variant' },
					{ id: 8, category: 'bracelet', name: 'دستبند طلا زنجیری', weight: 4.9, wage: 15, price: 44800000, icon: 'mdi-watch-variant' },
					{ id: 9, category: 'earring', name: 'گوشواره طلا میخی', weight: 1.5, wage: 19, price: 14200000, icon: 'mdi-ear-hearing' },
					{ id: 10, category: 'earring', name: 'گوشواره طلا آویز', weight: 2.8, wage: 21, price: 26500000, icon: 'mdi-ear-hearing' },
					{ id: 11, category: 'anklet', name: 'پابند طلا ظریف', weight: 3.2, wage: 16, price: 29800000, icon: 'mdi-foot-print' },
					{ id: 12, category: 'anklet', name: 'پابند طلا زنجیر', weight: 2.9, wage: 14, price: 26800000, icon: 'mdi-foot-print' },
				],
			}
		},
		computed: {
			filteredProducts() {
				return this.products.map(x => {
					let prd = { ...x }
					prd.price = prd.weight * this.goldPrice
					return prd
				}).filter(p => p.category === this.selectedCategory)
			}
		},
		methods: {
			selectCategory(id) {
				this.selectedCategory = id
			},
			formatPrice(val) {
				return Number(val).toLocaleString('fa-IR')
			},
		},
	}
</script>

<style scoped>

	.sg-list-enter-active,
	.sg-list-leave-active {
		transition: all 0.4s ease;
	}

	.sg-list-enter,
	.sg-list-leave-to {
		opacity: 0;
		transform: translateY(16px);
	}
</style>
